import React from 'react';
import { FileBarChart } from "lucide-react";

const Reports = () => {
  const data = [
    { id: "3", title: '5 / per year', date: '1', submittedBy: '4', status: '4', amount: '3' },
    { id: "4", title: '6 / per month', date: '2', submittedBy: '2', status: '4', amount: '5' },
    { id: "2", title: '4 / per year', date: '4', submittedBy: '4', status: '2', amount: '2' },
    { id: "3", title: '2 / per year', date: '5', submittedBy: '4', status: '7', amount: '2' },
  ];

  return (
    <div className="bg-gray-50 min-h-screen md:p-4">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">Reports</h1>
        </div>

        <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-blue-400">
                <tr>
                  <th className="px-6 py-3 text-center text-sm font-medium text-white tracking-wider">Select</th>
                  <th className="px-6 py-3 text-center text-sm font-medium text-white tracking-wider">HOA Fees Collected Per Month/Per Year</th>
                  <th className="px-6 py-3 text-center text-sm font-medium text-white tracking-wider">Not Paying Bills</th>
                  <th className="px-6 py-3 text-center text-sm font-medium text-white tracking-wider">Units Empty</th>
                  <th className="px-6 py-3 text-center text-sm font-medium text-white tracking-wider">Units Rented</th>
                  <th className="px-6 py-3 text-center text-sm font-medium text-white tracking-wider">Service Requests Created</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {data.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="px-6 py-4 text-center text-sm text-gray-500">No Data Found</td>
                  </tr>
                ) : (
                  data.map((item, index) => (
                    <tr key={item.id} className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex justify-center">
                          <input
                            type="checkbox"
                            className="rounded text-blue-500 focus:ring-blue-500 cursor-pointer"
                          />
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.title}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">{item.submittedBy}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">{item.id}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">{item.date}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">{item.amount}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reports;